onComplete(function () {

	// Popup
	var STORAGE_KEY = "gdsAnnouncePopupShown";
	var overlay = document.getElementById("announcePopupOverlay");
	if (!overlay) return;

	var alreadyShown = false;
	try {
		alreadyShown = sessionStorage.getItem(STORAGE_KEY) === "1";
	} catch (e) {
		// sessionStorage kan geblokkeerd zijn (privémodus e.d.); dan gewoon 1x per paginabezoek tonen
	}

	function closePopup() {
		overlay.classList.remove("active");
	}

	if (!alreadyShown) {
		overlay.classList.add("active");
		try {
			sessionStorage.setItem(STORAGE_KEY, "1");
		} catch (e) { }
	}

	document
		.getElementById("announcePopupClose")
		.addEventListener("click", closePopup);
	document
		.getElementById("announcePopupOk")
		.addEventListener("click", closePopup);
	overlay.addEventListener("click", function (e) {
		if (e.target === overlay) closePopup();
	});
	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape") closePopup();
	});

});